import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const TecRoute = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (user?.isTec ? (
      <Component />
    ) : (
      <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    ))}
  />
);

export { TecRoute };
